import React, {Fragment, ReactNode} from 'react';
import markerIcon from '@assets/images/icons/icon-location.svg';
import '@components/module-components/POSMap/pos-map.scss';
import {isValidLatLng} from '@components/module-components/POSMap/helper';
import {Marker} from '@react-google-maps/api';
import {ProcessStatus} from "@src/types";
import MarkerInfoBox from "@components/module-components/POSMap/helper/MarkerInfoBox";
import {ProcessData, MarkerOptions} from './types';

export const isMarkerClickable = (location: ProcessData): boolean => {
  const {process_status, status, custom_date} = location;
  return Boolean(
    status === Number(ProcessStatus.UPDATED) ||
    process_status === Number(ProcessStatus.UPDATED) ||
    (Number(ProcessStatus.MISSED) === (process_status || status) && custom_date)
  );
};

interface ProcessMarkerProps {
  isDrawMarker: boolean;
  location: ProcessData;
  opt: MarkerOptions;
  locClick: number | null;
  locHover: number | null;
  contentHover: ReactNode;
  contentClick: ReactNode;
  closeInfoBox: () => void;
  onInfoboxHover?: () => void;
  onInfoboxMouseOut?: () => void;
}

export const ProcessMarker: React.FC<ProcessMarkerProps> = (props) => {
  const {
    isDrawMarker,
    location,
    opt,
    locClick,
    locHover,
    contentHover,
    contentClick,
    closeInfoBox,
    onInfoboxHover,
    onInfoboxMouseOut
  } = props;

  // Validate the latitude and longitude
  if (!opt.position || !isValidLatLng(Number(opt.position.lat), Number(opt.position.lng))) {
    return null;
  }

  const showHoverContent = isDrawMarker && locHover === location.process_position_b2c;
  const showClickContent = isDrawMarker && locClick === location.process_position_b2c;

  return (
    <Fragment>
      <Marker
        icon={markerIcon}
        cursor="pointer"
        {...opt}
      >
        {(showHoverContent || showClickContent) && (
          <MarkerInfoBox
            position={opt.position}
            isHover={showHoverContent}
            onClose={showClickContent ? closeInfoBox : undefined}

            onInfoboxHover={onInfoboxHover}
            onInfoboxMouseOut={onInfoboxMouseOut}
          >
            {showHoverContent ? contentHover : contentClick}
          </MarkerInfoBox>
        )}
      </Marker>
    </Fragment>
  );
};

export default React.memo(ProcessMarker);